import { Container, CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GlobalStyles from './components/GlobalStyles';
import Widget from './components/Widget';
import { ToastContextProvider } from './contexts/ToastContext';
import theme from './theme';

const queryClient = new QueryClient();

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<ThemeProvider theme={theme}>
				<ToastContextProvider>
					<CssBaseline />
					<GlobalStyles />
					<div className="App">
						<Container maxWidth={"lg"}>
							<Widget />
						</Container>
					</div>
				</ToastContextProvider>
			</ThemeProvider>
		</QueryClientProvider>
	);
}

export default App;
